export default {
    data() {
        return {
            // 搜索表单数据
            form: {
                // 课程名称
                courseName: '',
                // 考卷标题
                paperTitle: '',
                // 备注
                remark: '',
                // 大于等于总分
                score_egt: '',
                // 小于等于总分
                score_eglt: '',
                // 是否随机出题
                random: false,
                // 是否禁用
                disable: false,
            },
            // 表格数据
            tableData: [
                {
                    id: 1,
                    paperTitle: '道路交通事故',
                    courseName: '道路交通事故',
                    singleChoiceNumber: 12,
                    singleChoiceScore: 55,
                    multipleChoiceNumber: 2,
                    multipleChoiceScore: 55,
                    trueOrFalseNumber: 12,
                    trueOrFalseScore: 55,
                    score: 99,
                    random: true,
                    timeLimit: 1800,
                    disable: false,
                    remark: '系统自动生成',
                    center: 107,
                },
                {
                    id: 2,
                    paperTitle: '道路交通事故',
                    courseName: '道路交通事故',
                    singleChoiceNumber: 12,
                    singleChoiceScore: 55,
                    multipleChoiceNumber: 2,
                    multipleChoiceScore: 55,
                    trueOrFalseNumber: 12,
                    trueOrFalseScore: 55,
                    score: 99,
                    random: true,
                    timeLimit: 1800,
                    disable: false,
                    remark: '系统自动生成',
                    center: 107,
                },
                {
                    id: 3,
                    paperTitle: '道路交通事故',
                    courseName: '道路交通事故',
                    singleChoiceNumber: 12,
                    singleChoiceScore: 55,
                    multipleChoiceNumber: 2,
                    multipleChoiceScore: 55,
                    trueOrFalseNumber: 12,
                    trueOrFalseScore: 55,
                    score: 99,
                    random: true,
                    timeLimit: 1800,
                    disable: false,
                    remark: '系统自动生成',
                    center: 107,
                },
            ],
            // 已选择的表格行
            selections: [],
            // 已选择的表格行的id
            selectionIds: [],
            // 总条数
            total: 20,
            // 当前页
            currentPage: 1,
            // 每页显示条数
            pageSize: 10,
            // 新增考卷数据
            addform: {
                // 考卷标题
                paperTitle: '',
                // 课程名称
                courseName: '',
                // 单选题数量
                singleChoiceNumber: '',
                // 单选题分数
                singleChoiceScore: '',
                // 多选题数量
                multipleChoiceNumber: '',
                // 多选题分数
                multipleChoiceScore: '',
                // 判断题数量
                trueOrFalseNumber: '',
                // 判断题分数
                trueOrFalseScore: '',
                // 试卷总分
                score: '',
                // 是否随机出题
                random: true,
                // 答题时间限制（秒）
                timeLimit: '',
                // 是否禁用
                disable: false,
                // 备注
                remark: '',
            },
            // 修改考卷数据
            editform: {
                // 考卷标题
                paperTitle: '',
                // 课程名称
                courseName: '',
                // 单选题数量
                singleChoiceNumber: '',
                // 单选题分数
                singleChoiceScore: '',
                // 多选题数量
                multipleChoiceNumber: '',
                // 多选题分数
                multipleChoiceScore: '',
                // 判断题数量
                trueOrFalseNumber: '',
                // 判断题分数
                trueOrFalseScore: '',
                // 试卷总分
                score: '',
                // 是否随机出题
                random: true,
                // 答题时间限制（秒）
                timeLimit: '',
                // 是否禁用
                disable: false,
                // 备注
                remark: '',
            },
            // 添加考卷对话框
            showAddPaperDialog: false,
            // 修改考卷对话框
            showEditPaperDialog: false,
        }
    },
    methods: {
        // 搜索
        search() {

        },

        // 当选择项发生变化时会触发该事件
        handleSelectionChange(selections) {
            this.selections = selections;
            // 取出选择的表格行的id
            this.selectionIds = selections.map(item => item.id);
        },

        // 点击新增按钮 
        handleAddPaper() {
            this.showAddPaperDialog = true;
        },

        // 确认新增
        addPaper() {
            this.$message.success('新增成功');
            this.showAddPaperDialog = false;
        },

        // 点击修改按钮
        handleEditPaper() {
            // 先判断是否有选择记录且最多选择一条记录
            if (this.selectionIds.length === 0 || this.selectionIds.length !== 1) {
                this.$message.warning('抱歉！请选择一条记录！');
                return;
            }

            this.showEditPaperDialog = true;

            this.editform = {
                paperTitle: '道路交通事故',
                courseName: '道路交通事故',
                singleChoiceNumber: 20,
                singleChoiceScore: 18,
                multipleChoiceNumber: 60,
                multipleChoiceScore: 10,
                trueOrFalseNumber: 30,
                trueOrFalseScore: 10,
                score: 95,
                random: true,
                timeLimit: 1800,
                disable: false,
                remark: '嘿嘿嘿',
            }
        },

        // 确定修改
        editPaper() {
            this.showEditPaperDialog = false;
        },

        // 点击删除按钮
        handleDeletePaper() {
            // 先判断是否有选择记录
            if (this.selectionIds.length === 0) {
                this.$message.warning('抱歉！请选择一条记录！');
                return;
            }

            this.$message.success('删除成功！');
        },

        // 每页显示条数改变时调用
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
        },

        // 当前页改变时调用
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage;
        },
    }
}